import { Table } from '@aws-amplify/ui-react'
import {
  Box,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'
import { useContext, useEffect } from 'react'

import {
  PassportContext,
  PassportContextInterface,
} from '../../../providers/Passport/PassportProvider'

export const PassportTable = ({
  patientId,
}: {
  patientId: string | undefined
}) => {
  const { getPatientPassportData, passportResponse } = useContext(
    PassportContext
  ) as PassportContextInterface

  useEffect(() => {
    if (patientId) {
      getPatientPassportData(parseInt(patientId))
    }
  }, [])

  const {
    providerHourRequirement,
    groupHourRequirement,
    totalHourRequirement,
    weeks,
  } = passportResponse

  const tableHeadCellStyle = {
    fontWeight: 900,
    fontSize: 16,
    textAlign: 'center',
  }

  const tableBodyCellStyle = { textAlign: 'center' }

  return (
    <Box>
      <Typography variant='h5'>Weekly Hour Requirements:</Typography>

      <TableContainer component={Paper} sx={{ mb: 2, maxWidth: 700 }}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell sx={tableHeadCellStyle}>Peer Group Hours</TableCell>
              <TableCell sx={tableHeadCellStyle}>
                Provider Appointment Hours
              </TableCell>
              <TableCell sx={tableHeadCellStyle}>Total Hours</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell sx={tableBodyCellStyle}>
                {groupHourRequirement.toFixed(2)}
              </TableCell>

              <TableCell sx={tableBodyCellStyle}>
                {providerHourRequirement.toFixed(2)}
              </TableCell>

              <TableCell sx={tableBodyCellStyle}>
                {totalHourRequirement.toFixed(2)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={tableHeadCellStyle}>Week</TableCell>

              <TableCell sx={tableHeadCellStyle}>Start of Week</TableCell>

              <TableCell sx={tableHeadCellStyle}>Peer Group Hours</TableCell>

              <TableCell sx={tableHeadCellStyle}>
                Provider Appointment Hours
              </TableCell>

              <TableCell sx={tableHeadCellStyle}>Total Hours</TableCell>

              <TableCell sx={tableHeadCellStyle}>Progress</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {weeks.map((week) => {
              const progress =
                totalHourRequirement > 0
                  ? Math.min(
                      (week.totalHours / totalHourRequirement) * 100,
                      100
                    )
                  : 0

              return (
                <TableRow key={week.weekNumber}>
                  <TableCell sx={tableBodyCellStyle}>
                    Week {week.weekNumber}
                    {week.isCurrentWeek && ' (Current)'}
                  </TableCell>

                  <TableCell sx={tableBodyCellStyle}>
                    {dayjs(week.startOfWeek).format('MM/DD/YYYY')}
                  </TableCell>

                  <TableCell sx={tableBodyCellStyle}>
                    {week.peerGroupsHours.toFixed(2)}
                  </TableCell>

                  <TableCell sx={tableBodyCellStyle}>
                    {week.providerAppointmentHours.toFixed(2)}
                  </TableCell>

                  <TableCell sx={tableBodyCellStyle}>
                    {week.totalHours.toFixed(2)}
                  </TableCell>

                  <TableCell sx={tableBodyCellStyle}>
                    {progress.toFixed(2)}%
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
